import { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useMutation, useQuery } from '@apollo/client'
import { useDispatch, useSelector } from 'react-redux'
import { FODBOLDHOLD_INVITE } from '../../graphql/queries'
import { JOIN_FODBOLDHOLD_INVITE, REGISTER } from '../../graphql/mutations'
import { loginFailure, loginStart, loginSuccess, clearError } from '../../store/slices/authSlice'
import { setCurrentUser } from '../../store/slices/mateSlice'
import { HoldScreen } from './bits'

function gqlError(error) {
  return error?.graphQLErrors?.[0]?.message || error?.message || 'Noget gik galt'
}

export default function InviteView() {
  const { token } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const isLoggedIn = useSelector((state) => state.auth.isAuthenticated && state.auth.token && state.mate.currentUser)
  const started = useRef(false)
  const [message, setMessage] = useState('')
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const info = useQuery(FODBOLDHOLD_INVITE, { variables: { token }, fetchPolicy: 'network-only' })
  const [joinInvite] = useMutation(JOIN_FODBOLDHOLD_INVITE)
  const [register] = useMutation(REGISTER)
  const invite = info.data?.fodboldholdInvite

  useEffect(() => {
    if (!isLoggedIn || !invite?.valid || started.current) return
    started.current = true
    setMessage('Du bliver medlem…')
    joinInvite({ variables: { token } })
      .then((result) => {
        const teamId = result.data?.joinFodboldholdInvite?.id || invite.teamId
        navigate(`/hold/${teamId}`, { replace: true })
      })
      .catch((error) => {
        started.current = false
        setMessage(gqlError(error))
      })
  }, [invite, isLoggedIn, joinInvite, navigate, token])

  const submit = async (event) => {
    event.preventDefault()
    dispatch(clearError())
    if (password !== confirmPassword) {
      setMessage('Adgangskoderne er ikke ens.')
      return
    }
    setBusy(true)
    setMessage('')
    dispatch(loginStart())
    try {
      const result = await register({
        variables: {
          email,
          password,
          name,
          signupToken: null,
          holdInvite: token,
        },
      })
      dispatch(loginSuccess({ token: result.data.register.token }))
      dispatch(setCurrentUser(result.data.register.mate))
      navigate(`/hold/${invite.teamId}`, { replace: true })
    } catch (error) {
      dispatch(loginFailure(gqlError(error)))
      setMessage(gqlError(error))
      setBusy(false)
    }
  }

  return (
    <HoldScreen>
      {info.loading ? <p className="hold-empty">Henter invitation…</p> : null}
      {!info.loading && !invite?.valid ? (
        <p className="hold-empty">Invitationen virker ikke længere.</p>
      ) : null}
      {invite?.valid && isLoggedIn ? <p className="hold-empty">{message || 'Du bliver medlem…'}</p> : null}
      {invite?.valid && !isLoggedIn ? (
        <form className="hold-form" onSubmit={submit}>
          <h2>Bliv medlem af {invite.teamName}</h2>
          <p className="hold-copy">Opret en bruger. Du bliver medlem af holdet og kun det hold.</p>
          <label>Navn<input value={name} onChange={(event) => setName(event.target.value)} required autoComplete="name" /></label>
          <label>Email<input type="email" value={email} onChange={(event) => setEmail(event.target.value)} required autoComplete="email" /></label>
          <label>Adgangskode<input type="password" value={password} onChange={(event) => setPassword(event.target.value)} required autoComplete="new-password" /></label>
          <label>Gentag adgangskode<input type="password" value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} required autoComplete="new-password" /></label>
          {message ? <p className="hold-note">{message}</p> : null}
          <button type="submit" className="hold-action hold-action--save" disabled={busy}>
            {busy ? 'Opretter…' : 'Opret og bliv medlem'}
          </button>
        </form>
      ) : null}
    </HoldScreen>
  )
}
